import React, { useState } from "react";
import style from './channelModal.module.scss';
import Button from "../../Button/button";
import Input from '../../input/input';

const ChannelModal = (props) => {

    return (
        <React.Fragment>
            <div className={style.contentWrapper}>
                {props.modalData.step == '1' ? <>
                    <div className={style.loginInputWrapper}>
                        <Input
                            label="ایمیل و یا شماره همراه"
                            placeholder="ایمیل و یا شماره همراه"
                            tag="addEmail"
                            value={props.modalData.value}
                            type="email"
                            error={props.modalData.err}
                            tooltip={"ایمیل و یا شماره همراه ثبت شده در پنل فروش"}
                            onchange={props.onchangeHandler}
                            onblur={props.onBlureHandler}
                            disabled={props.type == 'add' ? false : true}
                        />

                        <div className={style.buttonWrapper}>
                            <div className={style.button}>
                                <Button
                                    tag={props.modalData.step == '1' ? (props.type == 'add' ? "addSubmit" : "editSubmit") : (props.type == 'add' ? "submitCode" : "reSubmitCode")}
                                    loading={props.loading}
                                    type="solid"
                                    label={"تایید"}
                                    onclick={props.buttonHandler}
                                />
                            </div>
                        </div>
                    </div>
                    {(props.type == 'add') && <>
                        <span className={style.orCondition}>یا</span>
                        <div className={style.redirectToDK} onClick={() => {
                            if (props.type == 'edit') {
                                if (typeof props.modalData.is_version3 != 'undefined' && props.modalData.is_version3) {
                                    props.DKConnectionV3(props.type)
                                }
                            } else {
                                props.DKConnectionV3(props.type)
                            }
                        }}>
                            <div className={style.iconWrapper}></div>
                            <p className={style.textWrapper}>API اتصال به پنل دیجی‌کالا با</p>
                        </div>
                    </>}
                </>
                    :
                    <>
                        <Input
                            type="text"
                            label={"کد اعتبارسنجی"}
                            placeholder={"کد اعتبارسنجی"}
                            tag={props.type == 'add' ? "addConfirmCode" : "editConfirmCode"}
                            value={props.modalData.confirmCode}
                            error={props.modalData.confirmCodeErr}
                            tooltip={" کد تایید اعتبارسنجی پنل فروش"}
                            onchange={props.onchangeHandler}
                            onblur={props.onBlureHandler}
                        />

                        <div className={style.caution}>
                            <p>کد ارسالی دیجی‌کالا به ایمیل و یا شماره همراه خود را وارد کنید. ممکن است کد ارسالی به پوشه اسپم منتقل شده باشد.</p>
                            <div className={style.icon}>h</div>
                        </div>

                        <div className={style.buttonWrapper}>
                            <div className={style.button}>
                                <Button
                                    tag={props.modalData.step == '1' ? (props.type == 'add' ? "addSubmit" : "editSubmit") : (props.type == 'add' ? "submitCode" : "reSubmitCode")}
                                    loading={props.loading}
                                    type="solid"
                                    label={"تایید"}
                                    onclick={props.buttonHandler}
                                />
                            </div>
                        </div>
                    </>}
            </div>
        </React.Fragment>
    )
}
export default ChannelModal